<template>
  <div class="w-full">
    <div class="flex flex-col items-start justify-center w-full">
      <p class="font-semibold pb-3">My Friends to Play</p>
      <div class="rounded-lg p-3 bg-PRIMARY flex flex-row gap-3 w-full">
        <div class="bg-BLUEGREY p-2 rounded-lg w-10 h-10 flex items-center justify-center">
          <font-awesome-icon size="sm" class="black-icon" icon="fa-solid fa-user-plus " />
        </div>
        <div class="flex flex-col gap-1 justfiy-between items-start" @click="openInvite()">
          <p class="text-sm font-semibold">Invite your friends</p>
          <div class="flex flex-row gap-1">
            <img src="@/assets/icons/token-2.svg" class="w-4 h-4 object-contain" />
            <p class="text-xs">+5,000 for you and your friend</p>
          </div>
        </div>
      </div>
      <div class="mt-2 bg-PRIMARY flex flex-col rounded-lg p-4 gap-3 w-full items-start">
        <p class="text-sm">Share link to your friend</p>
        <div class="flex flex-row gap-3 justify-between w-full">
          <div class="bg-BLUEGREY rounded-lg flex flex-row p-3 items-center gap-2 shrink w-5/6">
            <font-awesome-icon class="black-icon" icon="fa-solid fa-link" />
            <p class="truncate text-xs text-black w-min">
              {{ referalLink }}
            </p>
          </div>
          <button
            @click="copyToClipboard(referalLink)"
            class="bg-[#4E5F9D] rounded-lg p-3 flex-1 flex items-center justify-center max-w-11 max-h-11"
          >
            <font-awesome-icon size="lg" icon="fa-solid fa-copy" />
          </button>
        </div>
      </div>
      <p class="font-semibold pb-3 pt-4">My Referral list</p>
      <div class="flex flex-col gap-3 w-full justify-center items-center">
        <div v-if="referals.length === 0" class="flex flex-col gap-4">
          <img class="h-40 object-contain mx-auto" src="../../assets/images/empty-state.svg">
          <p class="text-sm text-WHITE font-bold">No mates have joined your crew yet!</p>
        </div>
        <boost-item
          v-for="(referal, index) in referals"
          :key="index"
          :selected="currentTab === index"
          :title="referal.title"
          :icon="referal.icon"
          ><div class="flex flex-row gap-1 justify-center items-center">
            <p class="text-GREY text-xs">Level {{ referal.level }}</p>
          </div>
        </boost-item>
      </div>
    </div>
    <div
      v-if="showToast"
      class="fixed bottom-32 w-72 gap-3 left-1/2 -translate-x-1/2 text-base font-medium text-BLACK h-12 flex items-center justify-center rounded-lg bg-white"
    >
      <font-awesome-icon icon="fa-solid fa-check" class="green-icon" />
      Link Copied
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import WebApp from '@twa-dev/sdk'
import BoostItem from '../BoostItem.vue'
import { useClipboard } from '@vueuse/core'
import { listFriends } from '@/services'
import { useUserStore } from '@/stores/user'

WebApp.BackButton.show()

const userStore = useUserStore()

const isLoading = ref(false)
const referalLink = ref(`http://t.me/powtest_bot/pow?startapp=xld${userStore.telegramId}`)

const { text, copy, copied, isSupported } = useClipboard({ referalLink })

const showToast = ref(false)
const referals = ref([])

const copyToClipboard = (link) => {
  showToast.value = true
  setTimeout(() => {
    showToast.value = false
  }, 1500)
  copy(link)
}

const openInvite = () => {
  WebApp.openTelegramLink(`https://t.me/share/url?url=${referalLink.value}`)
}

const fetchFriendsList = async () => {
  isLoading.value = true
  const res = await listFriends()
  res.data.forEach((element) => {
    referals.value.push({
      title: `${element.first_name} ${element.last_name}`,
      icon: 'fa-regular fa-user',
      level: element.level
    })
  })
  isLoading.value = false
}

fetchFriendsList()
</script>

<style></style>
